import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import FileUpload from "../../components/common/FileUpload";
import { DataGrid, GridColumnMenu, GridToolbar } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import Badge from "@mui/material/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMagnifyingGlass,
  faSchool,
  faUserGraduate,
  faFileSignature,
  faIdBadge,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import SecCard from "../../components/common/SecCard";
import { Row, Col, Modal } from "react-bootstrap";
import { green, yellow, red, deepPurple } from "@mui/material/colors";
import { SERVER_ORIGIN } from "../../utilities/constants";
import {
  hasReadOnlyAccess,
  getDashboardPath,
} from "../../utilities/helper_functions";
import HeaderCard from "../../components/common/HeaderCard";
import BackButton from "../../components/common/BackButton";
import DropDown from "../../components/common/InstituteDropDown";
import TermsAndConditionsButton from "../../components/common/TermsAndConditionsModal";
import SchoolUpload from "../../components/common/SchoolUpload";
import DownloadSchoolExcel from "../../components/common/DownloadSchoolExcel";
import css from "../../css/admin/users-page.module.css";
import DownloadExcel from "../../components/common/DownloadExcel";

const AdminInstitutes = () => {
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const termsAcceptedParam = searchParams.get("termsAccepted");

  console.log("tabFromUrl>>", tabFromUrl);

  const [activeTab, setActiveTab] = useState(tabFromUrl || "institute");
  console.log("activeTab>>", activeTab);

  const [termsAccepted, setTermsAccepted] = useState(termsAcceptedParam || "");
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allInstitutes, setAllInstitutes] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [mouStatus, setMouStatus] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [all_institutes, setAll_institutes] = useState(0);
  const [all_mou_accepted, setAll_mou_accepted] = useState(0);
  const [all_mou_rejected, setAll_mou_rejected] = useState(0);
  const [all_mou_pending, setAll_mou_pending] = useState(0);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);   // optional – for nice UX
  const [
    all_institutes_onboarding_pending,
    setAll_institutes_onboarding_pending,
  ] = useState(0);
  const [
    all_institutes_onboarding_invited,
    setAll_institutes_onboarding_invited,
  ] = useState(0);
  const [all_institutes_email_sent, setAll_institutes_email_sent] = useState(0);
  const [
    all_institutes_onboarding_onboarded,
    setAll_institutes_onboarding_onboarded,
  ] = useState(0);
  const [all_institutes_email_not_sent, setAll_institutes_email_not_sent] =
    useState(0);
  const [termsAvailability, setTermsAvailability] = useState({});
  const [refreshCounter, setRefreshCounter] = useState(0);
  const currentUserType = sessionStorage.getItem("userType");
  const userRegion = sessionStorage.getItem("region");
  // const [refreshCounter, setRefreshCounter] = useState(0);
  // Near other states
  const [userType, setUserType] = useState(sessionStorage.getItem("userType") || "unknown");
  const [chapterEMs, setChapterEMs] = useState([]);
  const [selectedEM, setSelectedEM] = useState(null);           // for non-EM users
  // const [showUploadModal, setShowUploadModal] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  // New state for filters
  const [filters, setFilters] = useState({
    region: "",
    state: "",
    onboardingStatus: "",
    emailStatus: "",
    termsStatus: "",
  });
  // Thalir Cluster MOU upload stats (schools + students) keyed by instituteId
  const [clusterUploadStats, setClusterUploadStats] = useState({});
  const [clusterModalOpen, setClusterModalOpen] = useState(false);
  const [clusterModalData, setClusterModalData] = useState(null);

  const isReadOnly = hasReadOnlyAccess();
  const getRegionValue = (institute) => {
    const region = institute.region;

    if (!region || region === "NA" || region === "-") {
      return institute.chapterData?.region || "";
    }

    return region;
  };
  const uniqueRegions = [
    ...new Set(
      allInstitutes
        .map((item) => getRegionValue(item))
        .filter(Boolean)
    ),
  ];
  // Get unique values for dropdowns
  // const uniqueRegions = [
  //   ...new Set(allInstitutes.map((item) => item.region).filter(Boolean)),
  // ];
  const uniqueStates = [
    ...new Set(allInstitutes.map((item) => item.state).filter(Boolean)),
  ];

  // Helper function to get current financial year
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    if (currentMonth >= 4) {
      return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
      return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
    }
  };

  const refreshData = () => {
    setRefreshCounter((prev) => prev + 1);
  };
  // Function to check Terms availability for a specific institute
  const checkTermsAvailability = async (institute) => {
    if (!institute.createdBy) {
      console.log(`Institute ${institute.name} has no createdBy field`);
      return false;
    }

    try {
      const currentFinancialYear = getCurrentFinancialYear();
      // const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${institute.createdBy}/${currentFinancialYear}`;
      const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${currentFinancialYear}/${activeTab}`;

      const response = await fetch(termsUrl, {
        headers: {
          "auth-token": sessionStorage.getItem("token"),
        },
      });

      const responseText = await response.text();
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (parseError) {
        console.log(
          `Could not parse response as JSON for ${institute.name}:`,
          parseError
        );
      }

      let isAvailable = false;

      if (response.status === 200) {
        if (responseData && responseData.data) {
          const termsArray = responseData.data;
          if (Array.isArray(termsArray) && termsArray.length > 0) {
            isAvailable = true;
          } else if (termsArray && !Array.isArray(termsArray)) {
            isAvailable = true;
          } else {
            isAvailable = false;
          }
        } else {
          isAvailable = false;
        }
      } else if (response.status === 404) {
        isAvailable = false;
      } else {
        isAvailable = false;
      }

      return isAvailable;
    } catch (error) {
      console.error(
        "Error checking terms availability for",
        institute.name,
        ":",
        error
      );
      return false;
    }
  };

  // Function to check Terms availability for all institutes
  const checkAllTermsAvailability = async (institutes) => {
    const availability = {};
    const promises = institutes.map(async (institute) => {
      const isAvailable = await checkTermsAvailability(institute);
      availability[institute._id] = isAvailable;
    });
    await Promise.all(promises);
    setTermsAvailability(availability);
  };

  // Function to calculate Terms availability statistics
  const getTermsStatistics = () => {
    const availabilityValues = Object.values(termsAvailability);
    const totalInstitutes = availabilityValues.length;
    const availableCount = availabilityValues.filter(
      (isAvailable) => isAvailable === true
    ).length;
    const notAvailableCount = availabilityValues.filter(
      (isAvailable) => isAvailable === false
    ).length;

    return {
      total: totalInstitutes,
      available: availableCount,
      notAvailable: notAvailableCount,
    };
  };

  useEffect(() => {
    const fetchChapterEMs = async () => {
      if (userType === "em") return; // no need if user is EM

      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/em/auth/em/all?page=1&limit=100&sortBy=name&sortType=asc`,
          {
            headers: {
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch EMs");

        const result = await response.json();
        if (result.filteredInstitutes) {
          const emOptions = result.filteredInstitutes.map(em => ({
            value: em._id,
            label: `${em.name} (${em.chapterName || "No chapter"} - ${em.region || "?"})`,
          }));
          setChapterEMs(emOptions);
        }
      } catch (err) {
        console.error("Error loading Chapter EMs:", err);
        toast.error("Could not load Chapter EM list");
      }
    };

    // Optional: fetch only when modal is opened
    if (showUploadModal && userType !== "em") {
      fetchChapterEMs();
    }
  }, [showUploadModal, userType]);

  // Fetch Cluster MOU Thalir upload stats for this view (admin/region level)
  useEffect(() => {
    const fetchClusterStats = async () => {
      if (activeTab !== "thalir") {
        setClusterUploadStats({});
        return;
      }

      try {
        const adminId = process.env.REACT_APP_ADMIN_ID;
        const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
        const basicAuth =
          adminId && adminPassword ? btoa(`${adminId}:${adminPassword}`) : null;

        const response = await fetch(
          `${SERVER_ORIGIN}/api/admin/auth/thalir-uploaded-sheets`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              ...(basicAuth ? { Authorization: `Basic ${basicAuth}` } : {}),
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        if (!response.ok) {
          // Non-admin users may not have access – fail silently
          return;
        }

        const result = await response.json();
        if (!result?.data || !Array.isArray(result.data)) return;

        const map = {};
        // For admin API each log entry may repeat an institute; keep the latest only
        result.data.forEach((entry) => {
          if (!entry?.instituteId) return;
          const id = entry.instituteId;
          if (!map[id]) {
            map[id] = {
              instituteId: id,
              instituteName: entry.instituteName,
              schoolsCount: entry.schoolsCount || 0,
              totalStudentsFromSheet: entry.totalStudentsFromSheet || 0,
              uploadedAt: entry.uploadedAt,
              fileName: entry.fileName,
            };
          }
        });
        setClusterUploadStats(map);
      } catch (err) {
        console.error("Error loading Thalir Cluster upload stats (admin):", err);
      }
    };

    fetchClusterStats();
  }, [activeTab, refreshCounter]);

  const navigate = useNavigate();

  // Debounce search input to avoid frequent fetches while typing
  useEffect(() => {
    const handle = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      350
    );
    return () => clearTimeout(handle);
  }, [searchQuery]);

  useEffect(() => {
    async function getAllInstitutes() {
      setIsLoading(true);

      try {

        let regionQuery = "";

        if (currentUserType === "regionem" && userRegion) {
          regionQuery = `&region=${userRegion}`;
        }
        const response = await fetch(
          `${SERVER_ORIGIN}/api/institute/auth/institute/all?page=${page}&limit=${limit}&search=${debouncedSearch}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
          }&isThalir=${activeTab === "thalir" ? "true" : "false"}${termsAccepted ? `&termsAccepted=${termsAccepted}` : ""
          }${regionQuery}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            // navigate("/");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          console.log(
            "Successfully loaded institutes:",
            result.filteredInstitutes.length
          );
          setAllInstitutes(result.filteredInstitutes);
          setTotalPages(result.totalPages);
          setMouStatus(result.filteredInstitutes.mouStatus);

          if (
            result.filteredInstitutes &&
            result.filteredInstitutes.length > 0
          ) {
            checkAllTermsAvailability(result.filteredInstitutes);
          }
        }
      } catch (err) {
        setIsLoading(false);
      }
    }

    async function countingEM() {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${SERVER_ORIGIN}/api/admin/auth/insti-counting`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/login?userType=institute");
          }
        } else if (response.ok && response.status === 200) {
          setAll_institutes(result.data.all_institutes);
          setAll_mou_accepted(result.data.all_mou_accepted);
          setAll_mou_rejected(result.data.all_mou_rejected);
          setAll_mou_pending(result.data.all_mou_pending);
          setAll_institutes_onboarding_pending(
            result.data.all_institutes_onboarding_pending
          );
          setAll_institutes_onboarding_invited(
            result.data.all_institutes_onboarding_invited
          );
          setAll_institutes_email_sent(result.data.all_institutes_email_sent);
          setAll_institutes_onboarding_onboarded(
            result.data.all_institutes_onboarding_onboarded
          );
          setAll_institutes_email_not_sent(
            result.data.all_institutes_email_not_sent
          );
        } else {
          navigate("/login?userType=institute");
        }
      } catch (err) {
        // Handle error
      }
      setIsLoading(false);
    }

    setActiveTab(tabFromUrl || "institute");
    setTermsAccepted(termsAcceptedParam || "");
    countingEM();
    getAllInstitutes();
  }, [page, sortType, debouncedSearch, navigate, limit, mouStatus, activeTab, refreshCounter]);

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  // Apply filters to data
  const filteredInstitutes = allInstitutes.filter((institute) => {
    return (
      // (!filters.region || institute.region === filters.region) &&
      (!filters.region ||
        getRegionValue(institute) === filters.region) &&
      (!filters.state || institute.state === filters.state) &&
      (!filters.onboardingStatus ||
        institute.onboardingSatus === filters.onboardingStatus) &&
      (!filters.emailStatus ||
        institute.emailSentStatus === filters.emailStatus) &&
      (!filters.termsStatus ||
        (filters.termsStatus === "available"
          ? termsAvailability[institute._id]
          : filters.termsStatus === "not_available"
            ? !termsAvailability[institute._id]
            : true))
    );
  });

  const renderOnboardingStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = deepPurple[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      case "approved":
        statusColor = green[500];
        statusText = "Approved";
        textColor = "white";
        break;
      case "rejected":
        statusColor = red[500];
        statusText = "Rejected";
        textColor = "white";
        break;
      case "submitted":
        statusColor = yellow[500];
        statusText = "Submitted";
        textColor = "black";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            borderRadius: "8px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const renderEmailStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "sent":
        statusColor = green[500];
        statusText = "Sent";
        textColor = "white";
        break;
      case "not_sent":
        statusColor = red[500];
        statusText = "Not Sent";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            borderRadius: "8px",
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const rows = filteredInstitutes.map((institute, idx) => ({
    ...institute,
    region: getRegionValue(institute),
    id: idx + 1,
  }));
  // const rows = filteredInstitutes.map((institute, idx) => ({
  //   ...institute,
  //   id: idx + 1,
  // }));

  const entityName = activeTab === "institute" ? "College" : "School";

  const baseColumns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "name", headerName: `${entityName} Name`, width: 220 },
    { field: "officerName", headerName: "Coordinator Name", width: 180 },
    {
      field: "officerNumber",
      headerName: "Coordinator Number (10 digits)",
      width: 180,
    },
    { field: "officerEmail", headerName: "Coordinator Email", width: 240 },
    { field: "chapterEM", headerName: "Chapter EM", width: 240 },
    { field: "city", headerName: "City", width: 120 },
    { field: "state", headerName: "State", width: 140 },
    {
      field: "region",
      headerName: "Region",
      width: 140,
      valueGetter: (params) => {
        const region = params.row.region;

        if (!region || region === "NA" || region === "-") {
          return params.row.chapterData?.region || "-";
        }

        return region;
      },
    },
    { field: "chapterName", headerName: "Chapter Name", width: 160 },
    { field: "country", headerName: "Country", width: 130 },
    { field: "designation", headerName: "Designation", width: 150 },

    ...(activeTab === "thalir"
      ? [
        {
          field: "moutype",
          headerName: "MOU Type",
          align: "center",
          width: 150,

        },

      ]
      : []),
    {
      field: "mouDurhation",
      headerName: "Terms Status",
      width: 150,
      renderCell: (params) => {
        const { signDate, termsAcceptanceDate } = params.row;

        let statusText = "Pending";
        let statusClass = css.pendingStatus;

        if (!signDate && !termsAcceptanceDate) {
          statusText = "Not Accepted";
          statusClass = css.notAcceptedStatus;
        } else if (signDate && !termsAcceptanceDate) {
          statusText = "Accepted";
          statusClass = css.acceptedStatus;
        } else if (signDate && termsAcceptanceDate) {
          statusText = "Approved";
          statusClass = css.approvedStatus;
        }

        return <span className={statusClass}>{statusText}</span>;
      }
    },
    { field: "studentCount", headerName: "Student Count", width: 140 },
    {
      field: "lastLoginDate",
      headerName: "Last Login",
      width: 180,
      valueFormatter: (params) => {
        if (!params.value) return "Never";
        const date = new Date(params.value);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
    {
      field: "createdAt",
      headerName: "Created At",
      align: "center",
      width: 140,
      valueGetter: (params) => params.row.createdAt || params.row.createdAt || null,
      valueFormatter: (params) => {
        if (!params.value) return "-";
        const d = new Date(params.value);
        return d.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      align: "center",
      width: 140,
      valueGetter: (params) => params.row.updatedAt || params.row.createdAt || null,
      valueFormatter: (params) => {
        if (!params.value) return "-";
        const d = new Date(params.value);
        return d.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      renderCell: (params) => (
        <span style={{ whiteSpace: "normal", lineHeight: 1.3 }}>
          {params.formattedValue || params.value || "-"}
        </span>
      ),
    },

  ];

  const instituteExtraColumns = [
    ...(activeTab !== "thalir"
      ? [
        {
          field: "yuvaEcAssigned",
          headerName: "YUVA EC Assigned",
          width: 150,
          renderCell: (params) => {
            const count = params.row.yuvaEcCount || 0;
            return (
              <button
                type="button"
                onClick={() =>
                  navigate(
                    `/admin/institute-students/${params.row._id}?yuvaEcOnly=1`
                  )
                }
                title="View YUVA EC assigned students"
                className="btn btn-link p-0"
                style={{
                  textDecoration: "none",
                  lineHeight: 1,
                }}
              >
                <span
                  style={{
                    background: count > 0 ? "#28a745" : "#f1f1f1",
                    color: count > 0 ? "#fff" : "#555",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: 500,
                    display: "inline-block",
                  }}
                >
                  {count > 0 ? `Yes (${count})` : `No (0)`}
                </span>
              </button>
            );
          }
          // valueGetter: (params) =>
          //   params.row.yuvaEcAssigned ? "Yes" : "No",
        },
      ]
      : []),
    { field: "mouDuration", headerName: "Terms Duration", width: 140 },
    {
      field: "signDate",
      headerName: "Sign Date",
      width: 140,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },

    },
  ];

  const commonTailColumns = [
    // {
    //   field: "emailSentStatus",
    //   headerName: "Email Sent Status",
    //   width: 160,
    //   renderCell: renderEmailStatus,
    // },
    {
      field: "onboardingSatus",
      headerName: "Onboarding Status",
      width: 160,
      renderCell: renderOnboardingStatus,
    },
    {
      field: "mouStatus",
      headerName: "Terms & Conditions",
      width: 180,
      renderCell: (params) => (
        <TermsAndConditionsButton
          instituteId={params.row._id}
          text="View Terms"
          tabFromUrl={activeTab} // ✅ passing the right prop

        />
      ),
    },
    {
      field: "editDetails",
      headerName: "Edit",
      type: "actions",
      width: 150,
      align: "center",
      // renderCell: (params) => (
      //   <button
      //     className={css.viewBtn}
      //     onClick={() =>
      //       navigate(
      //         `/institutes/insert?edit=true&id=${encodeURIComponent(
      //           params.row._id
      //         )}&tab=${activeTab}`
      //       )
      //     }
      //   >
      //     Edit
      //   </button>
      // ),
      renderCell: (params) =>
        isReadOnly ? (
          <button className={`${css.viewBtn} ${css.disabledBtn}`} disabled>
            Edit
          </button>
        ) : (
          <button
            className={css.viewBtn}
            onClick={() =>
              navigate(
                `/institutes/insert?edit=true&id=${encodeURIComponent(
                  params.row._id
                )}&tab=${activeTab}`
              )
            }
          >
            Edit
          </button>
        ),
    },
    {
      headerName: "Action",
      type: "button",
      width: 230,
      // renderCell: (params) => (
      //   <div className="d-flex justify-content-between">
      //     <div className="mx-3">
      //       <DropDown _id={params.row._id} activeTab={activeTab} />
      //     </div>
      //   </div>
      // ),
      renderCell: (params) => {
        if (isReadOnly) {
          return (
            <div className={`${css.viewBtn} ${css.disabledBtn}`}>
              Action Disabled
            </div>
          );
        }

        const isThalirCluster =
          activeTab === "thalir" && params.row.moutype === "Cluster MOU";
        const stats = isThalirCluster
          ? clusterUploadStats[params.row._id]
          : null;

        const handleOpenClusterModal = () => {
          if (!stats) {
            toast.error(
              "No uploaded schools data found yet for this Cluster MOU institute."
            );
            return;
          }
          setClusterModalData({
            instituteName: params.row.name,
            chapterName: params.row.chapterName,
            region: params.row.region,
            city: params.row.city,
            ...stats,
          });
          setClusterModalOpen(true);
        };

        return (
          <div className="d-flex justify-content-between align-items-center gap-2">
            <div className="mx-1">
              <DropDown _id={params.row._id} activeTab={activeTab} />
            </div>
            {isThalirCluster && (
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={handleOpenClusterModal}
                style={{ whiteSpace: "nowrap" }}
              >
                View Upload Summary
              </button>
            )}
          </div>
        );
      },
    },
  ];

  // Final columns based on activeTab
  const columns =
    activeTab === "institute"
      ? [...baseColumns, ...instituteExtraColumns, ...commonTailColumns]
      : [...baseColumns, ...commonTailColumns];

  function handleInstitutesClick() {
    navigate(`/institutes/insert?tab=${activeTab}`);
  }

  function CustomColumnMenu(props) {
    return (
      <GridColumnMenu
        {...props}
        slotProps={{
          columnMenuUserItem: {
            displayOrder: 15,
            myCustomValue: "Do custom action",
            myCustomHandler: () => alert("Custom handler fired"),
          },
        }}
      />
    );
  }

  // Subtle elevation and lift-on-hover for header cards
  const ElevateOnHover = ({ children }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          borderRadius: 12,
          background: "#ffffff",
          transition: "box-shadow 200ms ease, transform 200ms ease",
          boxShadow: hovered
            ? "0 8px 24px rgba(16,24,40,.12)"
            : "0 1px 3px rgba(16,24,40,.06)",
          transform: hovered ? "translateY(-2px)" : "none",
        }}
      >
        {children}
      </div>
    );
  };

  // Reusable stat card with icon and soft gradient
  const StatCard = ({ title, value, icon, gradient }) => (
    <ElevateOnHover>
      <div className={css.dashboardCard} style={{ overflow: "hidden" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
          }}
        >
          <h3 className={css.cardTitle} style={{ margin: 0 }}>
            {title}
          </h3>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: gradient,
              color: "#fff",
            }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div className={css.cardContent} style={{ paddingTop: 0 }}>
          <div className={css.mainNumber}>{value}</div>
        </div>
      </div>
    </ElevateOnHover>
  );

  // Clear all filters
  const clearAllFilters = () => {
    setFilters({
      region: "",
      state: "",
      onboardingStatus: "",
      emailStatus: "",
      termsStatus: "",
    });
    setSearchQuery("");
  };

  return (
    <div className={css.outerDiv}>
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>

      {isReadOnly && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view all{" "}
            {activeTab === "institute" ? "institute" : "school"} data but cannot
            add, edit, or delete any records.
          </div>
        </div>
      )}

      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>
                {activeTab === "institute" ? "College Data" : "School Data"}
              </div>

              <div className={`${css.headerRight} d-flex align-items-center gap-3`}>
                {!isReadOnly && (
                  <>
                    <button
                      className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm"
                      // className={css.addBtn}
                      onClick={() =>
                        navigate(`/institutes/insert?tab=${activeTab}`)
                      }
                    >
                      <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                      Add {entityName}
                    </button>
                    {activeTab === "thalir" && (
                      <button
                        className="btn btn-outline-primary d-flex align-items-center gap-2 px-4 py-2 shadow-sm"
                        onClick={() => setShowUploadModal(true)}
                        style={{
                          borderRadius: '0.75rem',
                        }}
                      >
                        <i className="fas fa-file-excel"></i>
                        Upload Excel
                      </button>
                    )}
                    {/* NEW MODAL - Add this at the END of SecCard or component */}
                    {showUploadModal && activeTab === "thalir" && (
                      <Modal
                        show={showUploadModal}
                        onHide={() => {
                          setShowUploadModal(false);
                          setSelectedFile(null);
                          setSelectedEM(null);
                        }}
                        size="lg"
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Bulk Upload Schools</Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="p-4">

                          {/* 1. Download sample – make sure it's clickable */}
                          <div className="mb-5">
                            <h6 className="fw-bold mb-3">1. Download sample Excel template</h6>
                            <p className="text-muted small mb-3">
                              Use this exact format to avoid errors.
                            </p>

                            <DownloadSchoolExcel>
                              <button type="button" className="btn btn-outline-primary">
                                <i className="fas fa-download me-2"></i>
                                Download Sample
                              </button>
                            </DownloadSchoolExcel>
                          </div>

                          <hr className="my-4" />

                          {/* 2. Select EM (only if not logged in as EM) */}
                          {userType !== "em" && (
                            <div className="mb-4">
                              <label className="form-label fw-bold">
                                Assign to Chapter EM <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-select"
                                value={selectedEM?.value || ""}
                                onChange={(e) => {
                                  const em = chapterEMs.find((opt) => opt.value === e.target.value);
                                  setSelectedEM(em || null);
                                }}
                              >
                                <option value="">— Select Chapter EM —</option>
                                {chapterEMs.map((em) => (
                                  <option key={em.value} value={em.value}>
                                    {em.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          {/* 3. File selection & upload */}
                          <div>
                            <h6 className="fw-bold mb-3">3. Select Excel file</h6>

                            <SchoolUpload
                              emId={userType !== "em" ? selectedEM?.value : undefined}
                              onSuccess={() => {
                                refreshData();
                                setShowUploadModal(false);
                                setSelectedFile(null);
                                setSelectedEM(null);
                              }}
                            >
                              {({ handleFileRetrieve, handleFileUpload, fileUploaded, isUploading }) => (
                                <div className="mt-3">
                                  {/* Clickable area */}
                                  <div
                                    className={`border rounded p-5 text-center position-relative ${fileUploaded ? "border-success bg-success-subtle" : "border-dashed bg-light"
                                      }`}
                                    style={{ minHeight: "160px", cursor: "pointer" }}
                                    onClick={() => document.getElementById("hiddenFileInputModal")?.click()}
                                  >
                                    {fileUploaded ? (
                                      <>
                                        <i className="fas fa-file-excel fa-3x text-success mb-3"></i>
                                        <p className="fw-bold mb-1">File selected</p>
                                        {selectedFile && (
                                          <small className="text-muted">
                                            {selectedFile.name} • {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                                          </small>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <i className="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                                        <p className="mb-1 fw-medium">Click here or drag Excel file</p>
                                        <small className="text-muted">.xlsx / .xls only</small>
                                      </>
                                    )}

                                    {/* Hidden real input */}
                                    <input
                                      id="hiddenFileInputModal"
                                      type="file"
                                      accept=".xlsx,.xls"
                                      onChange={(e) => {
                                        if (e.target.files?.[0]) {
                                          setSelectedFile(e.target.files[0]);
                                          handleFileRetrieve(e);   // ← This MUST be called
                                        }
                                      }}
                                      style={{
                                        position: "absolute",
                                        inset: 0,
                                        opacity: 0,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </div>

                                  {/* Upload button */}
                                  <button
                                    className="btn btn-primary w-100 mt-4 py-2"
                                    onClick={handleFileUpload}
                                    disabled={!fileUploaded || isUploading || (userType !== "em" && !selectedEM?.value)}
                                  >
                                    {isUploading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Uploading...
                                      </>
                                    ) : (
                                      "Upload Schools Data"
                                    )}
                                  </button>
                                </div>
                              )}
                            </SchoolUpload>
                          </div>
                        </Modal.Body>

                        <Modal.Footer>
                          <button className="btn btn-outline-secondary px-4" onClick={() => setShowUploadModal(false)}>
                            Close
                          </button>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </>
                )}
              </div>
            </div>

            <Col md={6} lg={4} sm={12} xs={12}>
              <StatCard
                title={
                  activeTab === "institute"
                    ? "Total Colleges"
                    : "Total Schools"
                }
                value={allInstitutes.length}
                icon={faSchool}
                gradient="linear-gradient(135deg,#6366f1,#8b5cf6)"
              />
            </Col>

            <Col md={6} lg={4} sm={12} xs={12}>
              <StatCard
                title="Total Students"
                value={allInstitutes
                  .reduce(
                    (total, institute) => total + (institute.studentCount || 0),
                    0
                  )
                  .toLocaleString()}
                icon={faUserGraduate}
                gradient="linear-gradient(135deg,#10b981,#34d399)"
              />
            </Col>

            <Col md={6} lg={4} sm={12} xs={12}>
              <StatCard
                title="T&C Submitted"
                value={getTermsStatistics().available}
                icon={faFileSignature}
                gradient="linear-gradient(135deg,#f59e0b,#f97316)"
              />
            </Col>

          </Row>
        </SecCard>
      </div>

      {/* Search and Filters Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search</label>

            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search from the list"
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              {/* <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              /> */}
            </div>
          </div>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Region</label>
            <select
              value={filters.region}
              onChange={(e) => handleFilterChange("region", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Regions</option>
              {uniqueRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>State</label>
            <select
              value={filters.state}
              onChange={(e) => handleFilterChange("state", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All States</option>
              {uniqueStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Email Status</label>
            <select
              value={filters.emailStatus}
              onChange={(e) =>
                handleFilterChange("emailStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="sent">Sent</option>
              <option value="not_sent">Not Sent</option>
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Terms Status</label>
            <select
              value={filters.termsStatus}
              onChange={(e) =>
                handleFilterChange("termsStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="accepted">Accepted</option>
              <option value="approved">Approved</option>
              <option value="pending">Not Accepted</option>
            </select>
          </div>

          <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
            Clear All
          </button>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
        </div>
      )}

      {/* Cluster MOU Thalir upload summary modal */}
      <Modal
        show={clusterModalOpen}
        onHide={() => setClusterModalOpen(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cluster MOU – Uploaded Data Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {clusterModalData ? (
            <>
              <p>
                <strong>Institute:</strong> {clusterModalData.instituteName}
              </p>
              {clusterModalData.chapterName && (
                <p>
                  <strong>Chapter:</strong> {clusterModalData.chapterName}
                </p>
              )}
              <p>
                <strong>Location:</strong>{" "}
                {[clusterModalData.city, clusterModalData.region]
                  .filter(Boolean)
                  .join(", ")}
              </p>
              <hr />
              <p>
                <strong>Total Schools (from latest sheet):</strong>{" "}
                {clusterModalData.schoolsCount ?? 0}
              </p>
              <p>
                <strong>Total Students (from sheets):</strong>{" "}
                {clusterModalData.totalStudentsFromSheet ?? 0}
              </p>
              {clusterModalData.fileName && (
                <p>
                  <strong>Last Uploaded File:</strong>{" "}
                  {clusterModalData.fileName}
                </p>
              )}
              {clusterModalData.uploadedAt && (
                <p>
                  <strong>Last Uploaded On:</strong>{" "}
                  {new Date(
                    clusterModalData.uploadedAt
                  ).toLocaleString("en-GB")}
                </p>
              )}
              <p className="text-muted mt-3" style={{ fontSize: "0.9rem" }}>
                Counts shown above are derived from the latest uploaded Thalir
                school Excel sheet for this Cluster MOU institute.
              </p>
            </>
          ) : (
            <p>No upload data available for this institute.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setClusterModalOpen(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AdminInstitutes;
